<template>
  <div class="dateselect">
    <select
      v-model="year"
      @change="getMonthOptions()"
      :disabled="isDisabled"
      class="dateselectyear inputstyle col-md-2 blockmargin"
    >
      <option v-for="year in years" :key="year" :value="year">
        {{ year }}年
      </option>
    </select>
    <select
      v-model="month"
      @change="getDayOptions()"
      :disabled="isDisabled"
      class="dateselectmonth inputstyle col-md-2 blockmargin"
    >
      <option v-for="month in months" :key="month" :value="month">
        {{ month }}月
      </option>
    </select>
    <select
      v-model="day"
      :disabled="isDisabled"
      class="inputstyle col-md-2 blockmargin dateselectdate"
    >
      <option v-for="day in days" :key="day" :value="day">{{ day }}日</option>
    </select>
    <select
      v-model="hour"
      :disabled="isDisabled"
      class="inputstyle col-md-2 blockmargin dateselecthour"
    >
      <option v-for="hour in hours" :key="hour" :value="hour">
        {{ hour }}時
      </option>
    </select>
    <select
      v-model="minute"
      @change="getDate()"
      :disabled="isDisabled"
      class="inputstyle col-md-2 blockmargin dateselectminute"
    >
      <option v-for="minute in minutes" :key="minute" :value="minute">
        {{ minute }}分
      </option>
    </select>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isSuspension: {
      type: Boolean,
      default: false,
    },
    isTransactionList: {
      type: Boolean,
      default: false,
    },
    isEndTime: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // options
      years: [],
      months: [],
      days: [],
      hours: [],
      minutes: [],
      // time variable
      year: dayjs().year(),
      month: dayjs().month() + 1,
      day: dayjs().date(),
      hour: 0,
      minute: 0,
    }
  },
  methods: {
    getYearOptions() {
      /* 當下年份 */
      this.years.push(dayjs().year())
      /* 當下月份 */
      const currentMonth = dayjs().month() + 1
      if (this.isSuspension) {
        /* 若為停權使用的日期選擇，加入後一個年份 */
        this.years.push(dayjs().year() + 1)
      } else if (
        this.isTransactionList &&
        (currentMonth === 11 || currentMonth === 12)
      ) {
        /* 若為叫車紀錄總查詢使用的日期選擇，且目前為11或12月則加入後一個年份 */
        this.years.push(dayjs().year() + 1)
      } else {
        /* 其餘則加入前一個年份 */
        if (dayjs().month() - 11 < 0) {
          this.years.push(dayjs().year() - 1)
        }
      }
      this.getMonthOptions()
    },
    getMonthOptions() {
      this.months = []
      if (
        dayjs().isSame(`${this.year}-01-01`, 'month') ||
        dayjs().isBefore(`${this.year}-01-01`, 'month')
      ) {
        /* 若目前是n月則可以選擇1 ~ (n + 1)月，注意dayjs的月份是從0開始 */
        for (let idx = 0; idx < dayjs().month() + 1; idx++) {
          this.months.push(idx + 1)
        }
      } else {
        for (let idx = 0; idx < 12; idx++) {
          this.months.push(idx + 1)
        }
      }
      /* 若為設定停權的小視窗，今年(2025年)月份的選項可以從1月～12月 */
      if (this.isSuspension && this.year === 2025) {
        for (let idx = this.months.length; idx < 12; idx++) {
          this.months.push(idx + 1)
        }
      }
      this.getDayOptions()
    },
    getDayOptions() {
      this.days = []
      const daysInMonth = dayjs(`${this.year}-${this.month}-1`).daysInMonth()
      for (let idx = 0; idx < daysInMonth; idx++) {
        this.days.push(idx + 1)
      }
    },
    getHourMinOptions() {
      for (let idx = 0; idx < 60; idx++) {
        this.minutes.push(idx)
        if (idx < 24) {
          this.hours.push(idx)
        }
      }
    },
    getDate() {
      return dayjs(
        `${this.year}-${this.month}-${this.day} ${this.hour}:${this.minute}`,
      ).format('YYYY-MM-DD HH:mm')
    },
    setDate() {
      const baseDate = dayjs()
      let date = null

      if (this.isEndTime) {
        date = baseDate.endOf('day')
      } else {
        date = baseDate.startOf('day')
      }

      this.year = date.year()
      this.month = date.month() + 1
      this.day = date.date()
      this.hour = date.hour()
      this.minute = date.minute()
    },
  },
  mounted() {
    this.setDate()
    this.getYearOptions()
    this.getHourMinOptions()
  },
}
</script>



// WEBPACK FOOTER //
// src/components/tool/DateSelect.vue